import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import CustomCard from "../../d-reusable/CustomCard";
import "./style.css";

const CustomBarChart = ({ data }) => {
  // Array to map month numbers to month names and their abbreviations
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Get the current month index
  const currentDate = new Date();
  let currentMonthIndex = currentDate.getMonth();
  let currentYear = currentDate.getFullYear();

  // Get the last 6 months starting from the current month
  const recentMonths = [];
  for (let i = 5; i >= 0; i--) {
    const monthIndex = (currentMonthIndex - i + 12) % 12; // to handle negative indices for previous months
    const monthName = months[monthIndex];
    const monthAbbreviation = monthName.slice(0, 3); // Get the first 3 letters of the month name
    const year = monthIndex > currentMonthIndex ? currentYear - 1 : currentYear;

    recentMonths.push({
      name: `${monthAbbreviation} ${year}`, // Show both month & year
      value: data[monthName],
    });
  }
  return (
    <CustomCard>
      <div className="chart_card_container">
        <h6>No. of Projects</h6>
        <p>Last 6 Months</p>
      </div>
      <div style={{ width: "100%", height: 330 }}>
        <ResponsiveContainer>
          <BarChart data={recentMonths}>
            <CartesianGrid
              strokeDasharray="3 3"
              horizontal={true}
              vertical={false}
            />
            <XAxis dataKey="name" axisLine={false} tickLine={false} />
            <YAxis axisLine={false} tickLine={false} />
            {/* <Tooltip /> */}
            <Bar dataKey="value" fill="#50F5AE" barSize={30} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </CustomCard>
  );
};

export default CustomBarChart;
